const PRODUCT_SELECTOR = '.product-information';

function openSizeGuide(event) {
  const link = event.target.closest('.lfdy-size-guide-link');
  if (!link) return;

  const section = link.closest(PRODUCT_SELECTOR);
  const accordion = section?.querySelector('[id^="LfdyProductAccordion-"]');
  if (!accordion) return;

  event.preventDefault();
  const rows = accordion.querySelectorAll('details');
  const target = rows[1] || rows[0];
  if (!target) return;

  target.open = true;
  accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

document.addEventListener('click', openSizeGuide);
